import portfolio from './Favicon/portfolio.png'
import resume from './Favicon/resume.png'

export default {
  portfolio,
  resume,
}
